<template>
  <header class="dj-header dj-container">
    <img class="dj-header_title" @click="$router.push('/')" src="~@/assets/log.jpeg" alt="" style="width: 2rem; height: 2rem;">
    <nav class="dj-header_menu">
      <slot />
    </nav>
    <div class="dj-header_right">
      <slot name="right" />
    </div>
  </header>
</template>

<script>
export default {
  name: 'djHeader'
}
</script>

<style lang="scss">
.dj-header {
  display: flex;
  align-items: center;
  height: 4rem;
  line-height: 4rem;
  position: sticky;
  top: 0;
  z-index: 999;
  background-color: #ffffff;
  box-shadow: 0 0 2px 0 rgba($color: #000000, $alpha: 0.1);
  color: var(--main-font-color);
  .dj-header_title {
    margin-right: 3rem;
    font-size: 1.2rem;
    cursor: pointer;
    user-select: none;
  }
  .dj-header_menu {
    flex: 1;
    font-size: 1rem;
    .nav-item {
      position: relative;
      &.active {
        a {
          background-color: var(--active-color);
        }
      }
      a {
        padding: 0.5rem 1rem;
        transition: all 0.3s;
        border-radius: 1rem;
        color: var(--main-font-color);
      }
      & + .nav-item {
        margin-left: 1rem;
      }
    }
  }
  .dj-header_right {
    text-align: center;
    .ivu-icon {
      margin-right: 0.1rem;
    }
  }
}
</style>